var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.rating
    ? _c("div", { staticClass: "location-box__rating" }, [
        _c("div", { staticClass: "location-box__rating-logo" }, [
          _c("img", {
            staticClass: "location-box__rating-logo-image",
            attrs: { src: _vm.themeImagePath("google-logo.svg"), alt: "Google" }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "location-box__rating-content" }, [
          _c("div", { staticClass: "location-box__rating-stars" }, [
            _c(
              "div",
              { staticClass: "location-box__rating-stars-back" },
              _vm._l(_vm.stars.max, function(i) {
                return _c("SVGStarFilled", { key: i })
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "location-box__rating-stars-front" },
              [
                _vm._l(_vm.stars.full, function(i) {
                  return _c("SVGStarFilled", { key: i })
                }),
                _vm._v(" "),
                _vm.stars.half ? _c("SVGStarFilledHalf") : _vm._e()
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "location-box__rating-info" }, [
            _c("span", {
              staticClass: "location-box__rating-number-value",
              domProps: { innerHTML: _vm._s(_vm.rating) }
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "location-box__rating-number-label",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$tc("locations.rating.starsLabel", _vm.rating)
                )
              }
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "location-box__rating-count-value",
              domProps: { innerHTML: _vm._s(_vm.ratingsTotal) }
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "location-box__rating-count-label",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$tc("locations.rating.countLabel", _vm.ratingsTotal)
                )
              }
            })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }